import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { arrivalTimePage } from '../../utils';
import './ArrivalTimeCard.scss';

const ArrivalTimeCard = ({ arrivalStartTime, arrivalEndTime, isArrivalTimeEditable, setArrivalPageWasBooked }) => {
  const history = useHistory();
  return (
    <div className="arrival-time-card">
      <div className="arrival-time">
        <div className="label">Arrival Time</div>
        <div className="time">{`${arrivalStartTime} - ${arrivalEndTime}`}</div>
      </div>
      {
        isArrivalTimeEditable && (
          <div className="edit">
            <div
              onClick={() => {
                setArrivalPageWasBooked(false);
                history.push(arrivalTimePage);
              }}
            >
              Edit
            </div>
          </div>
        )
      }
      <div className="explanatory-text">
        Access to accommodation is 3pm for Premium accommodation and 4pm for all others, if a later arrival time is selected your room will be ready at the later time.
      </div>
    </div>
  );
};

ArrivalTimeCard.propTypes = {
  arrivalStartTime: PropTypes.string,
  arrivalEndTime: PropTypes.string,
  isArrivalTimeEditable: PropTypes.bool,
  setArrivalPageWasBooked: PropTypes.func,
};

export default ArrivalTimeCard;
